var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { writable } from 'svelte/store';
export var DialogLock;

(function (DialogLock) {
  DialogLock[DialogLock["FREE"] = 0] = "FREE";
  DialogLock[DialogLock["LOCKED"] = 1] = "LOCKED";
  DialogLock[DialogLock["WARN"] = 2] = "WARN";
})(DialogLock || (DialogLock = {}));

var DIALOGS = [];

var _writable = writable(DIALOGS),
    subscribe = _writable.subscribe,
    update = _writable.update;

var pipeCatch = function pipeCatch(e) {
  return e && Promise.reject(e);
};

export var dialogs = {
  subscribe: subscribe,
  show: function show(Component) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var strict = props.strict,
        rest = __rest(props, ["strict"]);

    var promise = new Promise(function (resolve, reject) {
      return rest.DialogPromise = {
        resolve: resolve,
        reject: reject,
        locking: DialogLock.FREE
      };
    });
    update(function (dialogs) {
      dialogs.push({
        Component: Component,
        props: rest
      });
      return dialogs;
    });
    return strict ? promise : promise.catch(pipeCatch);
  },
  showOnce: function showOnce(Component) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return dialogs.has(Component) ? undefined : dialogs.show(Component, props);
  },
  hide: function hide(index) {
    update(function (dialogs) {
      dialogs.splice(index, 1);
      return dialogs;
    });
  },
  has: function has(Component) {
    for (var i = DIALOGS.length - 1; i > -1; i--) {
      if (DIALOGS[i].Component === Component) return true;
    }

    return false;
  }
};